import { render, staticRenderFns } from "./SliLinkSeizureModal.vue?vue&type=template&id=21f1ba06"
import script from "./SliLinkSeizureModal.vue?vue&type=script&lang=js"
export * from "./SliLinkSeizureModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports